import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import axios from "axios";

interface AuthContextType {
  isAuthenticated: boolean;
  setIsAuthenticated: (value: boolean) => void;
  checkAuth: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("iso_access_token="))
      ?.split("=")[1];
    return Boolean(token);
  });

  const checkAuth = useCallback(async () => {
    try {
      const response = await axios.get<{ authenticated: boolean }>(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth-check`,
        { withCredentials: true }
      );
      setIsAuthenticated(response.data.authenticated);
    } catch (error) {
      console.error("認証チェックエラー:", error);
      setIsAuthenticated(false);
    }
  }, []);

  useEffect(() => {
    checkAuth(); // 初回マウント時に常に認証確認
  }, [checkAuth]);

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, setIsAuthenticated, checkAuth }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};
